<template>
  <v-runtime-template :template="includeTemplate"/>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'

export default {
  name: 'Confirm',
  components: {
    VRuntimeTemplate
  },
  props: {
    step: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      includeHtml: '',
      basePath: this.getStore('mmpAuth').state.basePath
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    }
  },
  watch: {
  },
  beforeUpdate () {
  },
  updated () {
  },
  async created () {
    if (isEmpty(wepHtmlToString.fourthSubTemplate)) {
      this.getEmptyTemplate('wepConfirm.html')
    } else {
      this.includeHtml = wepHtmlToString.fourthSubTemplate
    }
  },
  methods: {
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.fourthSubTemplate = res
        this.includeHtml = wepHtmlToString.fourthSubTemplate
      })
    },
    fnTab () {
      let obj = {
        stepNum: this.step,
        params: {
        }
      }
      this.$emit('fnTab', obj)
    },
    async fnResult () {
      let obj = {
        stepNum: this.step,
        regFlag: ''
      }

      let params = {
        mbrFnm: '',
        emailAddr: ''
      }

      let result = {}

      result = this.documentValidate()
      if (result.flag) {
        params.mbrFnm = result.input[0].data.trim()
        params.emailAddr = result.input[1].data.trim()
        params.wepId = this.getStore('mmpAuth').state.saveId
        let resultInfo = await this.$http.mmp.memberInfo(this, params)
        if (resultInfo.data.status !== 'OK') {
          obj.regFlag = '02'
          this.$emit('confirmResult', obj)
        } else {
          obj.regFlag = '01'
          this.$emit('confirmResult', obj)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/Confirm.vue